// extracted by mini-css-extract-plugin
module.exports = {"login-content":"phoneForm_login-content__iK6M8"};